<template>
    <Pagebody style="margin:0 auto;float:none;" :loading='false'>
        <div style='height:100px;'></div>
        <div class="backImg"></div>
        <h1 class='transfer_title'>订单支付成功，<span>{{sec}}</span>秒后将关闭页面。</h1>
        <div style='height:250px;'></div>
    </Pagebody>
</template>
<script>
    import wh from '@/assets/js/wh.js'
    export default {
        name: 'payBack',
        data: () => ({
            sec: 5
        }),
        mounted() {
            setInterval(() => {
                this.sec--
                if (this.sec == 0) {
                    
                    window.close();
                }
            }, 1000)
        }
    }
</script>
<style scoped>
    .transfer_title {
        line-height: 50px;
        font-weight: normal;
        text-align: center;
        font-size: 18px;
        width: 335px;
        margin: 0 auto;
        padding: 0;
        margin-bottom: 30px;
        padding-left: 20px;
        background: url(../assets/image/success.png) no-repeat left center;
    }
    .backImg {
        height: 162px;
        background: url(../assets/image/guanbi.jpg) no-repeat center top;
    }
</style>